import Layouts from "./layouts";
import SegmentFamilies from "constants/segment-families";

const {
  // plop_marker:segment_index_import_layout
  StarShape,
  RectangleShape,
} = Layouts;

export default { 
  // plop_marker:segment_index_add_layout
  StarShapeComponent: {
    family: SegmentFamilies.SHAPE,
    type: "StarShapeComponent",
    title: "Star",
    imgSrc: "/static/img/segments/layouts/star-shape.png",
    config: StarShape.StarShapeConfig,
    advancedConfig: StarShape.StarShapeAdvancedConfig,
    component: StarShape.StarShapeComponent
  },
  RectangleShapeComponent: {
    family: SegmentFamilies.SHAPE,
    type: "RectangleShapeComponent",
    title: "Rectangle",
    imgSrc: "/static/img/segments/layouts/rectangle-shape.png",
    config: RectangleShape.RectangleShapeConfig,
    advancedConfig: RectangleShape.RectangleShapeAdvancedConfig,
    component: RectangleShape.RectangleShapeComponent
  },
};